import { useState } from 'react'
import HomeFloatingSelect from '@/components/shared/HomeFloatingSelect'
import { DEFAULT_ASK_BAR_AGENT_ID } from './askBarSelectionDefaults'
import { HOME_AGENT_SELECT_OPTIONS } from './homeAgentSelectOptions'

export default function AiAskBarHomeAgentFloatingSelect({ value, onChange }) {
  const [localAgent, setLocalAgent] = useState(DEFAULT_ASK_BAR_AGENT_ID)
  const isControlled = value != null
  const agent = isControlled ? value : localAgent
  const handleChange = (next) => {
    if (!isControlled) setLocalAgent(next)
    onChange?.(next)
  }

  return (
    <HomeFloatingSelect
      aria-label="Select agent"
      placeholder="Select Agent"
      menuTitle="Agent"
      value={agent}
      options={HOME_AGENT_SELECT_OPTIONS}
      onChange={handleChange}
    />
  )
}
